import { lazy } from 'react';

import type { RouteConfig } from '../../types';

const DashboardLayout = lazy(() => import('@/layouts/DashboardLayout'));
const StructureVersionsLayout = lazy(() => import('@/pages/structureVersions/layout'));
const StructureVersionsListPage = lazy(() => import('@/pages/structureVersions'));
const StructureVersionCreatePage = lazy(() => import('@/pages/structureVersions/create'));
const StructureVersionDetailPage = lazy(() => import('@/pages/structureVersions/detail'));
const StructureVersionMarketsPage = lazy(() => import('@/pages/structureVersions/detail/markets'));
const StructureVersionMarketViewPage = lazy(() => import('@/pages/structureVersions/detail/markets/view'));
const StructureVersionStatesPage = lazy(() => import('@/pages/structureVersions/detail/states'));
const StructureVersionStateViewPage = lazy(() => import('@/pages/structureVersions/detail/states/view'));
const StructureVersionProjectsPage = lazy(() => import('@/pages/structureVersions/detail/projects'));

/**
 * Structure version routes: the versions grid, the create page, a version's detail page and its
 * Markets / States / Projects as they were at that version, with the market and state view pages.
 * `StructureVersionsLayout` mounts the section breadcrumb. Permissions: `@/config/auth/routeAccess`.
 */
export const structureVersionRoutes: RouteConfig = {
  path: '/structure-versions',
  layout: DashboardLayout,
  children: [
    {
      path: '',
      layout: StructureVersionsLayout,
      children: [
        { path: '', element: StructureVersionsListPage },
        { path: '/create', element: StructureVersionCreatePage },
        {
          path: '/:versionId',
          children: [
            { path: '', element: StructureVersionDetailPage },
            {
              path: '/markets',
              children: [
                { path: '', element: StructureVersionMarketsPage },
                { path: '/:marketId/view', element: StructureVersionMarketViewPage },
              ],
            },
            {
              path: '/states',
              children: [
                { path: '', element: StructureVersionStatesPage },
                { path: '/:stateCode/view', element: StructureVersionStateViewPage },
              ],
            },
            { path: '/projects', element: StructureVersionProjectsPage },
          ],
        },
      ],
    },
  ],
};
